export default "__VITE_ASSET__DOpgEe9j__"